// extracted by mini-css-extract-plugin
export var video = "styles-module--video--29QEi";
export var replayButton = "styles-module--replayButton--1zbad";
export var active = "styles-module--active--3UQXJ";